<template>
  <div id="J_xingBoxBbb" class="section section2">
    <div class="section-con">
      <img
        :src="emptyImage"
        class="fullpage-item-holder"
        style="display: inline;"
      />
      <div id="J_xingBbb" class="xing"></div>
      <div class="content-pos">
        <span class="tit up-ani"></span>
        <div class="section2-con up-ani clearfix">
          <div class="swiper-box">
            <swiper
              v-if="newsSwiperList.length > 1"
              class="swiper"
              :options="swiperOption"
            >
              <swiper-slide v-for="(item, i) in newsSwiperList" :key="i">
                <!-- <div class="slider-img-box"> -->
                <a :href="item.jumpLink" target="_blank" class="slider-img-box">
                  <img :src="item.img" alt="ffbewotv" class="slider-img" />
                </a>
                <!-- </div> -->
              </swiper-slide>
              <div slot="button-prev" class="swiper-button-prev"></div>
              <div slot="button-next" class="swiper-button-next"></div>
            </swiper>
          </div>
          <div class="news-box">
            <ul class="news-tabs clearfix">
              <li
                v-for="(item, i) in tabsList"
                :key="i"
                class="news-tabs-item "
                :class="{ active: curTab === i }"
                @click="changeTab(i)"
              >
                {{ item.catname }}
              </li>
            </ul>
            <div :class="{ ani: isStyle }" class="list">
              <ul v-if="newsList.length > 0" class="news-list">
                <li
                  v-for="(item, i) in newsList"
                  :key="i"
                  class="news-item"
                  @click="jumpDetail(item)"
                >
                  <a target="_blank">
                    <span class="news-txt">【{{ clx }}】{{ item.title }}</span>
                    <span class="news-time">{{ getDate(item) }}</span>
                  </a>
                </li>
              </ul>
              <p v-else class="no-data">敬请期待</p>
            </div>
            <div target="_blank" class="check-all" @click="jumpNewsList">
              <i class="add">+</i>查看全部
            </div>
          </div>
        </div>
        <ul class="ad-list up-ani clearfix">
          <li v-for="(item, i) in adList" :key="i" class="ad-item">
            <a :href="item.jumpLink">
              <img :src="item.img" alt="ffbewotv" class="ad-img" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// '最新', '新闻', '公告', '活动', '攻略'
import { mapState, mapActions } from "vuex";
import { getEmptySVG } from "@/libs/svg";
import Common from "./Common";

export default {
  name: "Section2",
  mixins: [Common],
  data() {
    return {
      clx: "最新",
      isStyle: true,
      jumpUrl: "//ffbewotv.seayoo.com/latest.html",
      list: [],
      newsList: [],
      swiperOption: {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      emptyImage: getEmptySVG(1920, 1080)
    };
  },
  computed: {
    ...mapState(["curTab", "adList", "newsSwiperList", "tabsList", "channel"])
  },
  mounted() {
    // https://ffbewotv.dsi.seayoo.com/article?filter:catid=6419
    // https://ffbewotv.dsi.seayoo.com/article?s=5
    this.changeCurTab(0);
    // this.getType();
    // 最新列表
    this.getNewslist();
    const xingbox = document.getElementById("J_xingBoxBbb");
    const xing = document.getElementById("J_xingBbb");
    xingbox.onmousemove = function(e) {
      const x = (e.clientX * 50) / window.innerWidth;
      const y = (e.clientY * 50) / window.innerHeight;
      xing.style.transform = `translate(${x}px,${y}px)`;
    };
  },
  methods: {
    ...mapActions(["changeCurTab"]),
    jumpNewsList() {
      this.$router.push({ path: "/news" });
    },
    getDate(item, isFull) {
      const unixTime = item.inputtime ? item.inputtime : item.created;
      const time = new Date(unixTime),
        month = time.getMonth() + 1,
        day = time.getDate();
      let ymdhis = "";
      ymdhis += time.getFullYear() + "-";
      if (month < 10) {
        ymdhis += "0" + month + "-";
      } else {
        ymdhis += month + "-";
      }
      if (day < 10) {
        ymdhis += "0" + day;
      } else {
        ymdhis += day;
      }
      if (isFull === true) {
        if (time.getHours() < 10) {
          ymdhis += " 0" + time.getHours() + ":";
        } else {
          ymdhis += " " + time.getHours() + ":";
        }
        if (time.getMinutes() < 10) {
          ymdhis += "0" + time.getMinutes();
        } else {
          ymdhis += time.getMinutes();
        }
      }
      return ymdhis;
    },
    changeTab(ind) {
      if (this.curTab !== ind) {
        this.isStyle = false;
        this.changeCurTab(ind);
        this.clx = this.tabsList[ind].catname;
        this.getNewslist(this.tabsList[ind].catid);
        this.jumpUrl = this.tabsList[ind].url;
      }
    },
    async getNewslist(id) {
      try {
        let params = {
          df: "catid,title,description,inputtime,thumb",
          s: 5,
          sort: 'data.inputtime'
        }
        if(id) {
          params['filter:catid'] = id
        }
        const {
          data: { items }
        } = await this.$api.getKMSConfig("article", params);
        if (items.length === 0) return;
        this.isStyle = true;
        this.newsList = items;
      } catch (error) {
        this.$toast(error?.desc || "Error");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.section2 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: inherit;
  background: url("~@/assets/images/bg_02.jpg") no-repeat center top / cover;
  .section-con {
    position: relative;
    .mixin_com(width, 1160);
  }
  .xing {
    position: absolute;
    top: 0;
    left: 0;
    .mixin_com(width, 1920);
    .mixin_com(height, 1080);

    background:
      url("~@/assets/images/section2/dd.png") no-repeat center top /
      cover;
    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
    transition-duration: 1000ms;
    transition-property: transform;
    transform-origin: center center;
    .mixin_com(width, 1920);
    .mixin_com(height, 1080);
  }
  .sec2-main {
    position: absolute;
    top: 0;
    left: 0;
  }
  .tit {
    display: block;
    .mixin_com(width, 1019);
    .mixin_com(height, 185);

    margin: 0 auto;
    .mixin_com(margin-top, 120);
    .mixin_com(margin-bottom, 38);

    background:
      url("~@/assets/images/section2/tit2.png") no-repeat center top /
      cover;
  }
  .section2-con {
    display: block;
    .mixin_com(width, 1160);

    margin: 0 auto;
    animation-delay: 0.9s;
  }
  .swiper-box {
    .mixin_com(width, 578);
    .mixin_com(height, 360);

    float: left;
    background-color: #000;
  }
  .slider-img-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .mixin_com(height, 360);

    overflow: hidden;
  }
  .slider-img {
    max-width: 100%;
  }
  .swiper-button-prev,
  .swiper-button-next {
    .mixin_com(width, 55);
    .mixin_com(height, 76);
  }
  .swiper-button-prev {
    background:
      url("~@/assets/images/section2/left_arr.png") no-repeat center
      top / cover;
    transform: translateY(-50%);
  }
  .swiper-button-next {
    background:
      url("~@/assets/images/section2/right_arr.png") no-repeat center
      top / cover;
    transform: translateY(-50%);
  }
  .swiper-button-next::after,
  .swiper-container-rtl .swiper-button-prev::after {
    content: "";
  }
  .swiper-button-prev::after,
  .swiper-container-rtl .swiper-button-next::after {
    content: "";
  }
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 1;
  }
  .news-box {
    position: relative;
    .mixin_com(width, 577);
    .mixin_com(height, 360);
    .mixin_com(padding-top, 36);
    .mixin_com(padding-left, 30);
    .mixin_com(padding-right, 30);

    float: left;
    overflow: hidden;
    .mixin_com(font-size, 20);

    color: #fff;
    background:
      url("~@/assets/images/section2/newsbg.jpg") no-repeat center top /
      cover;
    background-color: #181f32;
    opacity: 0.7;
  }
  .news-tabs {
    display: block;
    width: 100%;
    font-family: "FZFW-ZhuZiAOldMin-B--GB1-0";
    .mixin_com(border-width, 1);

    border-bottom-color: #5c6278;
    border-bottom-style: solid;
  }
  .news-tabs-item {
    .mixin_com(width, 62);
    .mixin_com(padding-bottom, 4);

    float: left;
    text-align: center;
    cursor: pointer;
    &.active {
      .mixin_com(border-width, 4);

      color: #ffe983;
      border-bottom: 4px solid #ffe983;
    }
  }
  .list {
    position: relative;
    opacity: 0;
    .news-item {
      position: relative;
      // .mixin_com(padding-top, 10);
      // .mixin_com(padding-bottom, 2);

      cursor: pointer;
      border-bottom: 1px solid #5c6278;
      a {
        color: #fff;
        transition: all 0.3s;
        &:hover {
          color: #ffe983;
        }
      }
      &:last-child {
        border-bottom: none;
      }
    }
    .news-txt {
      display: inline-block;
      .mixin_com(width, 400);
      .mixin_com(height, 30);

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .news-time {
      position: absolute;
      right: 0;
      .mixin_com(bottom, 6);
      .mixin_com(font-size, 18);
    }
    &.ani {
      opacity: 1;
      transition: all 0.3s;
      transition-delay: 0.3s;
    }
  }
  .check-all {
    position: absolute;
    .mixin_com(right, 35);
    .mixin_com(bottom, 16);

    line-height: 1.2;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s;
    .add {
      display: inline-block;

      .mixin_com(width, 16);
      .mixin_com(height, 15);
      .mixin_com(margin-right, 8);

      text-indent: -9999px;
      vertical-align: sub;
      background:
        url("~@/assets/images/section2/add.png") no-repeat left top /
        100%;
    }
    &:hover {
      color: #ffe983;
    }
  }
  .ad-list {
    display: block;
    .mixin_com(width, 1160);

    margin: 0 auto;
    .mixin_com(margin-top, 35);

    animation-delay: 1.1s;
    .ad-item {
      .mixin_com(width, 360);
      .mixin_com(height, 170);
      .mixin_com(margin-right, 37);

      float: left;
      &:last-child {
        margin-right: 0;
      }
    }
    .ad-img {
      width: 100%;
      height: 100%;
      .transition(0.3s);
      &:hover {
        .transform(scale(1.05));
      }
    }
  }
  .no-data {
    .mixin_com(font-size, 14);
    .mixin_com(padding-top, 20);

    text-align: center;
  }
}
</style>
